module.exports = __webpack_public_path__ + "img/slogan_ru.6cef10be.svg";